import { StyleSheet, View } from 'react-native'
import { Image } from '../Image/Image.js'

export const SpriteImage = ({ width, height, rows, columns, row, column, style, ...props }) => {
  const imgWidth = width * columns
  const imgHeight = height * rows
  const left = -width * column
  const top = -height * row
  return (
    <View
      style={StyleSheet.compose(
        { width, height, overflow: 'hidden', backgroundColor: 'black' },
        style,
      )}
    >
      <Image
        {...props}
        style={{ position: 'absolute', left, top }}
        width={imgWidth}
        height={imgHeight}
      />
    </View>
  )
}
